<div class="step-container">
  <h3 class="step-title">Supporting Documents</h3>
  <p class="step-subtitle">
    Upload your organization's documents to help expedite verification. Accepted: JPG, PNG, PDF (max 10 MB each).
  </p>

  <div class="doc-types">
    <div class="doc-type-chip">
      <mat-icon>article</mat-icon>
      <span>IRS Determination Letter (501c3)</span>
    </div>
    <div class="doc-type-chip">
      <mat-icon>badge</mat-icon>
      <span>Government-issued ID</span>
    </div>
    <div class="doc-type-chip">
      <mat-icon>account_balance</mat-icon>
      <span>Voided Check / Bank Letter</span>
    </div>
  </div>

  <!-- Drop Zone -->
  <div
    class="drop-zone"
    [class.drag-over]="dragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
    (click)="fileInput.click()"
  >
    <mat-icon class="upload-icon">cloud_upload</mat-icon>
    <p class="drop-text">Drag & drop files here, or <strong>click to browse</strong></p>
    <p class="drop-hint">JPG, PNG, PDF up to 10 MB</p>
    <input
      #fileInput
      type="file"
      multiple
      accept=".jpg,.jpeg,.png,.pdf"
      style="display: none"
      (change)="onFileSelected($event)"
    >
  </div>

  <!-- Upload Progress -->
  <div *ngFor="let key of uploadingKeys" class="upload-progress-item">
    <mat-icon class="file-icon">upload_file</mat-icon>
    <div class="progress-info">
      <span class="file-name">{{ key }}</span>
      <mat-progress-bar mode="determinate" [value]="uploadProgress[key]"></mat-progress-bar>
      <span class="progress-pct">{{ uploadProgress[key] }}%</span>
    </div>
  </div>

  <!-- Uploaded Files List -->
  <div *ngIf="uploadedFiles.length > 0" class="uploaded-list">
    <h4>Uploaded Files</h4>
    <div *ngFor="let file of uploadedFiles; let i = index" class="uploaded-item">
      <mat-icon class="file-icon" [class.pdf]="file.type === 'application/pdf'">
        {{ file.type === 'application/pdf' ? 'picture_as_pdf' : 'image' }}
      </mat-icon>
      <div class="file-info">
        <span class="file-name">{{ file.name }}</span>
        <span class="file-size">{{ formatBytes(file.size) }}</span>
      </div>
      <a [href]="file.url" target="_blank" mat-icon-button class="view-btn">
        <mat-icon>open_in_new</mat-icon>
      </a>
      <button mat-icon-button (click)="removeFile(i)" class="remove-btn" title="Remove">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="form-actions">
    <button mat-stroked-button (click)="skipStep()" [disabled]="isSaving || isUploading">
      Skip for now
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onContinue()"
      [disabled]="uploadedFiles.length === 0 || isUploading || isSaving"
    >
      <mat-spinner *ngIf="isSaving" diameter="20" class="btn-spinner"></mat-spinner>
      <span>{{ isSaving ? 'Saving...' : 'Save & Continue' }}</span>
    </button>
  </div>
</div>
